import { Injectable } from '@angular/core';
import {
  HttpEvent,
  HttpInterceptor,
  HttpHandler,
  HttpRequest,
  HttpHeaders,
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { LoginService, User } from '../../services/login.service';

@Injectable()
export class SolutionInterceptor implements HttpInterceptor {

  user: User | null = null;

  constructor( private loginService: LoginService) {

    this.user = this.loginService.userSubject.getValue();
    this.loginService.userSubject.subscribe({
      next: (user: User | null) => {
        this.user = user;
      }
    });
  }


  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<any>> {

    let modifiedRequest = req;
    if(this.user){
      const client_hash = this.user.token ? this.user.token : '';
      let headers = new HttpHeaders({
        'Authorization': client_hash,
      });
      headers = headers.append('Content-Type', 'application/json');
      modifiedRequest = req.clone({ headers: headers });
    }
    
    return next.handle(modifiedRequest);

  }


}
